
import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

// Components

import SummaryItem from '../SummaryItem';

// Constants

import { ETHNICITY_LIST } from '@constants/ssap/hhmTypes/ethnicityList';
import { NO_PRIOR_DATA } from '@constants/ssap/miscellaneous/miscellaneous';
import { RACES_LIST } from '@constants/ssap/hhmTypes/racesList';


const RaceAndEthnicityInfo = props => {

    const {
        ethnicityAndRace: {
            ethnicity,
            race,
            hispanicLatinoSpanishOriginIndicator
        },
        idx
    } = props;

    const intlApi = useIntl();

    const getValues = (groups = [], list, notSupported)  => {
        if (groups.length === 0) {
            return NO_PRIOR_DATA;
        }

        return groups
            .map(group => {
                const {
                    code,
                    label
                } = group;

                const groupFromList = list
                    .find(listedGroup => {
                        const {
                            code: listedGroupCode
                        } = listedGroup;

                        return listedGroupCode === code;
                    });

                const labelFromList = groupFromList
                    ? groupFromList.label
                    : intlApi.formatMessage(
                        { id: notSupported },
                        { code }
                    );

                return labelFromList === ''
                    ? label === ''
                        ? intlApi.formatMessage({ id: 'ssap.input.label.other' })
                        : label
                    : intlApi.formatMessage({ id: labelFromList });
            })
            .join('; ');
    };

    return (
        <Fragment>
            <SummaryItem
                nullValue = 'ssap.summary.null_value.hispanic_origin'
                textCode = 'common.hispanic_latino_origin'
                value = { hispanicLatinoSpanishOriginIndicator }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].ethnicityAndRace.hispanicLatinoSpanishOriginIndicator`
                        ]
                    ]
                }
            />

            {
                race.length > 0 &&

                <SummaryItem
                    textCode = 'common.race'
                    value = { getValues(race, RACES_LIST, 'common.non_supported_race') }
                    ignoreIntl
                    desc = {
                        [
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].ethnicityAndRace.race`
                                ],
                                getValues,
                                [
                                    RACES_LIST,
                                    'common.non_supported_race'
                                ]
                            ]
                        ]
                    }
                />
            }

            {
                ethnicity.length > 0 &&

                <SummaryItem
                    textCode = 'common.ethnicity'
                    value = { getValues(ethnicity, ETHNICITY_LIST, 'common.non_supported_ethnicity') }
                    ignoreIntl
                    desc = {
                        [
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].ethnicityAndRace.ethnicity`
                                ],
                                getValues,
                                [
                                    ETHNICITY_LIST,
                                    'common.non_supported_ethnicity',
                                ]
                            ]
                        ]
                    }
                />
            }
        </Fragment>
    );
};

export default RaceAndEthnicityInfo;